import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AUTH_TOKEN_KEY } from '@/services/apiService';

function getSessionId() {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
}

function isAdmin(): boolean {
  // Jeśli w localStorage jest token admina, to znaczy że jesteśmy zalogowani jako admin
  return !!localStorage.getItem(AUTH_TOKEN_KEY);
}

export function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Nie śledzimy stron admina
    if (location.pathname.startsWith('/admin')) return;

    // Nie śledzimy wizyt zalogowanego admina — żeby nie zawyżać statystyk
    if (isAdmin()) return;

    const trackPage = async () => {
      try {
        await fetch('/api/analytics/track', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            path: location.pathname + location.search,
            session_id: getSessionId(),
            user_agent: navigator.userAgent
          })
        });
      } catch (err) {
        // Ciche ignorowanie błędów analityki, żeby nie przeszkadzać użytkownikowi
      }
    };
    
    trackPage();
  }, [location]);

  return null;
}

export default PageTracker;
